import { GlobalStorage } from '@feedyou/schema'
import { parseJsonSafe } from '@feedyou/utils'

export function getTypeError(formData: FormData) {
  const value = formData.value as any

  switch (formData.type) {
    case 'number':
      if (isNaN(Number(value))) {
        return 'You have selected type "number" - value must be a number.'
      }
      break

    case 'array':
      if (!Array.isArray(parseJsonSafe(value ?? "''"))) {
        return 'You have selected type "array" - value must be a valid array.'
      }
      break

    case 'object':
      const parsedVal = parseJsonSafe(value ?? "'")
      if (typeof parsedVal !== 'object' || parsedVal === null || Array.isArray(parsedVal)) {
        return 'You have selected type "object" - value must be a valid non-array object.'
      }
      break

    case 'boolean':
    case 'string':
    default:
      return null
  }
}

export type FormData = Omit<GlobalStorage, 'value'> & { value: string | boolean }

export function toFormData(storage: GlobalStorage): FormData {
  function getValue() {
    switch (storage.type) {
      case 'number':
        return storage.value
      case 'boolean':
        return storage.value
      case 'array':
      case 'object':
        return JSON.stringify(storage.value, null, 2)
      case 'string':
      default:
        return storage.value ?? ''
    }
  }

  // @ts-ignore
  return { ...storage, value: getValue() }
}

export function fromFormData(formData: FormData): GlobalStorage {
  function getValue() {
    switch (formData.type) {
      case 'number':
        return Number(formData.value)
      case 'boolean':
        return formData.value
      case 'array':
      case 'object':
        return JSON.parse(formData.value as string)
      case 'string':
        return formData.value
    }
  }
  // @ts-ignore
  return { ...formData, value: getValue() }
}
